import { defineNamespace } from '@/i18n';
import { en } from './en';
import { fr } from './fr';

/** The vehicles feature's messages: `const t = useT(messages)`. */
export const messages = defineNamespace('vehicles', fr, en);
